@if (isOpened) {
  <div [@fadeIn]="isOpened" class="overlay"></div>
}

@if (isOpened) {
  <div class="dial-wrapper" (capClickOutside)="close()">
    <div class="dial-center">
      @for (button of dialButtons; track button) {
        <div
          class="dial-button"
          [@main]="{
            value: isOpened ? 'show' : 'hide',
            params: { x: button.x, y: button.y, ox: 0, oy: 0 },
          }">
          <div
            [pTooltip]="button.tooltipText"
            class="circle-icon-block"
            tooltipPosition="top"
            [tooltipDisabled]="disableTooltip"
            tooltipStyleClass="rotary-dial-tooltip"
            (click)="onDialButtonClick(button)">
            @if (button.iconName) {
              <i [class]="button.iconName"></i>
            }
            @if (!button.iconName && button.iconPath) {
              <img [src]="button.iconPath" [alt]="button.iconName" />
            }
          </div>
        </div>
      }
    </div>
  </div>
}
